'use client'

import { useController, useSocialController } from '@/core/hooks/useSWRApi'
import { CompetitionChannelResource } from '@rallycry/api-suite-typescript'
import {
  BracketMatchChannelControllerApi,
  CommunityChannelControllerApi,
  CompetitionChannelControllerApi
} from '@rallycry/api-suite-typescript/dist/apis'
import { ChatControllerApi } from '@rallycry/social-api-typescript/dist/apis'
import { useSocialUserContext } from './useSocialUserContext'

export const useChatTicket = () => {
  const { ctrl: communityCtrl } = useController(CommunityChannelControllerApi)
  const { ctrl: competitionCtrl } = useController(
    CompetitionChannelControllerApi
  )
  const { ctrl: matchCtrl } = useController(BracketMatchChannelControllerApi)
  const { ctrl } = useSocialController(ChatControllerApi)
  const { activeChats } = useSocialUserContext()

  const handleJoinChat = async (channel: CompetitionChannelResource) => {
    const name = channel?.socialId || channel?.externalId
    if (activeChats?.some(it => it === name)) {
      return // already in chat
    }

    let ticket
    if (name?.includes('BRACKET_MATCH')) {
      ticket = await matchCtrl().obtainBracketMatchChannelTicket({
        id: channel?.id!
      })
    } else if (name?.includes('COMPETITION')) {
      ticket = await competitionCtrl().obtainCompetitionChannelTicket({
        competitionId: channel?.id! // this is true by convention
      })
    } else if (name?.includes('COMMUNITY')) {
      ticket = await communityCtrl().obtainCommunityChannelTicket({
        communityId: channel?.id! // this is true by convention
      })
    }

    if (!ticket?.ticket) {
      throw new Error('Unsupported ticket chat type')
    }

    await ctrl({ ticket: ticket.ticket }).joinChat({
      id: name!,
      chatJoinCommand: {
        name: ticket.name!,
        image: ticket.image!,
        accessLevel: ticket.accessLevel!,
        disambiguatingDescription: ticket.disambiguationDescription
      }
    })
  }
  return { handleJoinChat }
}
